"use strict";

// 横スクロールする比較表に「スクロールできます」の指示を出す（scroll-hint）
// PC と同じ表の形を保ったまま横に流すので、はみ出しているうちだけ出る
{
  window.addEventListener("DOMContentLoaded", function () {
    if (typeof ScrollHint === "undefined") {
      return;
    }

    // 表を崩さない下限幅を割るのは tab-down なので、そこだけ有効にする
    if (!window.matchMedia("(max-width: 1024px)").matches) {
      return;
    }

    new ScrollHint(".js-scrollable", {
      i18n: {
        scrollable: "スクロールできます",
      },
    });
  });
}
